export default {
  details: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    fontSize: '2rem',
    height: '95%'
  },
  wiringInfo: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '2rem'
  },
  networkClosetIcon: {
    fontSize: '2.5rem',
    verticalAlign: '-.25em',
    marginRight: '.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/WiredDeviceDetails/exportStyle.js